<div *ngIf="activeStep == 2">
  <lib-ksf-price-card
    [errorIngetInsurancePrices]="errorIngetInsurancePrices"
    [errorInKSFPrice]="errorInKSFPrice"
    [allHaveTogglePricetag]="allHaveTogglePricetag"
    [ksfPriceLoading]="ksfPriceLoading"
    [ksfExcessTab]="ksfExcessTab"
    [ksfPrice]="ksfPrice"
    [showYearlyPrice]="showYearlyPrice"
    [ksfPriceResult]="ksfPriceResult"
    [vehicleFromDmr]="vehicleFromDmr"
    [ksfTemplate]="ksfTemplate"
    (recalculateKsfPricesEvent)="recalculateKsfPrice()"
    (setKsfTemplateEvent)="ksfTemplate = $event"
    (setKsfExcessTabEvent)="ksfExcessTab = $event"
    (pickKsfEvent)="pickKsf($event)"
  ></lib-ksf-price-card>
</div>

<!-- ######  Step 3 KSF ###### -->
<div
  *ngIf="showKsfInfo && activeStep > 2"
  class="max-w-[85rem] lg:px-8 py-10 mx-auto"
>
  <div *ngIf="activeStep == 3 && showKsfInfo">
    <ng-container *ngIf="!showClauses && !showWarring">
      <div class="grid md:grid-cols-2">
        <lib-ksf-info
          [ksfPriceResult]="ksfPriceResult"
          [selectedFieldsValues]="selectedFieldsValues"
          [showFieldIndexArray]="showFieldIndexArray"
          [ksfPriceLoading]="ksfPriceLoading"
          [ksfTemplate]="ksfTemplate"
          (setShowWarringEvent)="showWarring = $event"
          (setShowClausesEvent)="showClauses = $event"
          (setSelectedFieldsValuesEvent)="selectedFieldsValues = $event"
          (setShowFieldIndexArrayEvent)="showFieldIndexArray = $event"
          (recalculateKsfPricesEvent)="recalculateKsfPrice()"
          (setKsfTemplateEvent)="ksfTemplate = $event"
          (nextStepEvent)="nextStep()"
        ></lib-ksf-info>

        <lib-ksf-side-display
          [showYearlyPrice]="showYearlyPrice"
          [ksfPrice]="ksfPrice"
          [ksfPriceResult]="ksfPriceResult"
          [ksfPriceLoading]="ksfPriceLoading"
          (togglePriceIntervalEvent)="togglePriceInterval()"
        ></lib-ksf-side-display>
      </div>
    </ng-container>

    <!-- ###### KSF Clauses ###### -->
    <ng-container *ngIf="showClauses">
      <lib-ksf-clauses-display
        [ksfPriceResult]="ksfPriceResult"
        [ksfPriceLoading]="ksfPriceLoading"
        (nextStepEvent)="nextStep()"
      ></lib-ksf-clauses-display>
    </ng-container>

    <!-- ###### KSF Warrings ###### -->
    <ng-container *ngIf="showWarring">
      <lib-ksf-warrings-display
        [ksfPriceResult]="ksfPriceResult"
        [errorIngetInsurancePrices]="errorIngetInsurancePrices"
        [allHaveTogglePricetag]="allHaveTogglePricetag"
        [showYearlyPrice]="showYearlyPrice"
        [vehicleFromDmr]="vehicleFromDmr"
        [errorInSJFPrice]="errorInSJFPrice"
        [errorInHelvetiaPrice]="errorInHelvetiaPrice"
        [helvetiaMonthlyPrice]="helvetiaMonthlyPrice"
        [helvetiaYearlyPrice]="helvetiaYearlyPrice"
        [helvetiaVariants]="helvetiaVariants"
        [selectedHelvetiaVariant]="selectedHelvetiaVariant"
        (setSelectedHelvetiaVariantEvent)="setSelectedHelvetiaVariant($event)"
        [forsiaExcessPrices]="forsiaExcessPrices"
        [forsiaPrices]="forsiaPrices"
        [selectedforsiaExcessIndex]="selectedforsiaExcessIndex"
        [forsiaTotalPrice]="forsiaTotalPrice"
        [forsiaPriceLoading]="forsiaPriceLoading"
        (pickHelvetiaEvent)="pickHelvetiaEvent.emit($event)"
        (pickSjfEvent)="pickSjfEvent.emit($event)"
      ></lib-ksf-warrings-display>
    </ng-container>
  </div>

  <div *ngIf="activeStep == 4 && showKsfInfo">
    <div class="grid md:grid-cols-2">
      <lib-ksf-coverage-selection
        [textDirectedToCustomer]="textDirectedToCustomer"
        [allHaveToggleChargingStandAllowed]="allHaveToggleChargingStandAllowed"
        [ksfCoverages]="ksfCoverages"
        [showYearlyPrice]="showYearlyPrice"
        [vehicleFromDmr]="vehicleFromDmr"
        [ksfTemplate]="ksfTemplate"
        [chargingStand]="chargingStand"
        (recalculateKsfPricesEvent)="recalculateKsfPrice()"
        (setKsfTemplateEvent)="ksfTemplate = $event"
        (setChargingStandEvent)="chargingStand = $event"
        (nextStepEvent)="nextStep()"
      >
      </lib-ksf-coverage-selection>

      <lib-ksf-side-display
        [showYearlyPrice]="showYearlyPrice"
        [ksfPrice]="ksfPrice"
        [ksfPriceResult]="ksfPriceResult"
        [ksfPriceLoading]="ksfPriceLoading"
        (togglePriceIntervalEvent)="togglePriceInterval()"
      ></lib-ksf-side-display>
    </div>
  </div>

  <div *ngIf="activeStep == 5 && showKsfInfo">
    <div class="grid md:grid-cols-2">
      <lib-ksf-customer-info
        [ksfPriceResult]="ksfPriceResult"
        [ksfCustomerInfo]="ksfCustomerInfo"
        [textDirectedToCustomer]="textDirectedToCustomer"
        (setCustomerInfoEvent)="setCustomerInfo($event)"
        (nextStepEvent)="nextStep()"
      >
      </lib-ksf-customer-info>
      <lib-ksf-side-display
        [showYearlyPrice]="showYearlyPrice"
        [ksfPrice]="ksfPrice"
        [ksfPriceResult]="ksfPriceResult"
        [ksfPriceLoading]="ksfPriceLoading"
        (togglePriceIntervalEvent)="togglePriceInterval()"
      ></lib-ksf-side-display>
    </div>
  </div>

  <div *ngIf="activeStep == 6 && showKsfInfo">
    <lib-ksf-accept-conditions
      [chargingStand]="chargingStand"
      [ksfCustomerInfo]="ksfCustomerInfo"
      [ksfTemplate]="ksfTemplate"
      [vehicleFromDmr]="vehicleFromDmr"
      [ksfAcceptConditions]="ksfAcceptConditions"
      [carOwnershipType]="carOwnershipType"
      [selectedPrice]="selectedPrice"
      [dealerId]="dealerId"
      [leadOrigin]="leadOrigin"
      [textDirectedToCustomer]="textDirectedToCustomer"
      (nextStepEvent)="nextStep()"
    ></lib-ksf-accept-conditions>
  </div>

  <div *ngIf="activeStep == 7 && showKsfInfo">
    <lib-success-step
      [make]="vehicleFromDmr.make"
      [model]="vehicleFromDmr.model"
      [InsurranceCompany]="'ksf'"
      [activeStep]="activeStep"
      [textDirectedToCustomer]="textDirectedToCustomer"
      (resetEvent)="reset()"
    ></lib-success-step>
  </div>
</div>
